import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout center" }

import NavHeader from "../components/nav/NavHeader.vue";
import SeComboBox from "../components/global/SeComboBox.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_SeLoadingIndicator = _resolveComponent("SeLoadingIndicator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SeLoadingIndicator)
  ]))
}
}

})